import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useAuth } from '../../contexts/AuthContext'
import { useLocalizedNavigate } from '../../hooks/useLocalizedNavigate'

export default function PaymentSuccess() {
  const { t } = useTranslation()
  const navigate = useLocalizedNavigate()
  const { refresh } = useAuth()

  useEffect(() => {
    document.title = `${t('payment.successTitle')} | ${t('common.appName')}`
    // Refresh auth to pick up new credits
    refresh()
  }, [refresh, t])

  return (
    <div className="container">
      <div className="card text-center" style={{ maxWidth: '500px', margin: '3rem auto' }} role="status">
        <FontAwesomeIcon
          icon="check"
          style={{ fontSize: '3rem', color: 'var(--success)', marginBottom: '1rem' }}
        />
        <h1>{t('payment.successTitle')}</h1>
        <p className="text-gray mb-4">{t('payment.successMessage')}</p>

        <div className="flex gap-2 justify-center">
          <button className="btn btn-primary" onClick={() => navigate('/')}>
            {t('payment.goHome')}
          </button>
          <button className="btn btn-outline" onClick={() => navigate('/account')}>
            {t('payment.viewAccount')}
          </button>
        </div>
      </div>
    </div>
  )
}
